export const DOCS_URL = `${process.env.PUBLIC_URL || ''}/docs/index.html`;
